// extracted by mini-css-extract-plugin
export default {"container":"StakingSection_container__CaIpn","title":"StakingSection_title__Mkj+3","contents":"StakingSection_contents__E7LRW"};